const USER_ROUTES = {
    ADD_USER: 'user/add',
    GET_USER: 'user/list',
    UPDATE_USER: 'user/update',
    DELETE_USER: 'user/delete',


}

export default USER_ROUTES;